var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("\n       "+_vm._s(_vm.isEnglish ? 'contact number':'联系电话')+"： "),_c('a',{attrs:{"href":'tel:'+_vm.tourInfo.settings.phone}},[_vm._v("\n        "+_vm._s(_vm.tourInfo.settings.phone)+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f1eebf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/tourKefu.vue
// module id = null
// module chunks = 